// extracted by mini-css-extract-plugin
export var fileExt = "_s3-8";
export var fileIcon = "_s3-6";
export var fileLink = "_s3-5";
export var fileName = "_s3-7";
export var image = "_s3-1";
export var imageError = "_s3-3";
export var imageErrorIcon = "_s3-4";
export var imageLink = "_s3-0";
export var imageLoaded = "_s3-2";